import $ from 'jquery';
import CFAJAXHandler from './CFAJAXHandler';

$.extend({
  CFAJAXHandler: function resolve(options) {
    const CFAJAXHandlerInstance = new CFAJAXHandler(options);

    return CFAJAXHandlerInstance.resolve();
  },

  setCFAJAXHandlerDefaults: CFAJAXHandler.setDefaults,
});



// WEBPACK FOOTER //
// ./assets/js/cf-ajax-handler/main.js